
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"c-info\">\n    <div class=\"c-channel__content\">\n        <div class=\"c-channel__icon\" style=\"background-image:url(")
    ; __append(escape(channelIcon))
    ; __append(");\"></div>\n        <div class=\"c-channel__name\">")
    ; __append(escape(channelName))
    ; __append("</div>\n       ")
    ;  if (isApp) { 
    ; __append("\n         <div class=\"c-channel__subscribe plus\">关注</div>\n        ")
    ; }
    ; __append("\n    </div>\n    ")
    ;  if (showOnlineNum) { 
    ; __append("\n        <div class=\"c-visite\"><span class=\"num\"></span>人参与</div>\n    ")
    ;  } 
    ; __append("\n    <div class=\"c-info__btn selected\">详情</div>\n</div>\n<div class=\"c-info__content\">\n    ")
    ; __append(escape(intro))
    ; __append("\n</div>\n\n")
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/modules/info/main.ejs
// module id = 612
// module chunks = 0